export default {"src":"/_next/static/image/public/images/ic_account_circle_grey.cc67a38688aa5c78f743ce6880aac8aa.svg","height":16,"width":16};